import { render, staticRenderFns } from "./CreateLeadPopout.vue?vue&type=template&id=63ed209d&"
import script from "./CreateLeadPopout.vue?vue&type=script&lang=ts&"
export * from "./CreateLeadPopout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports